import type { PointsBalanceResponse } from '@api/mesa/graphql'
import { mesaColorNames, typography } from '@/src/common/theme'
import { type TextStyle, TouchableOpacity, Text } from 'react-native'
import { usePoints } from '@/src/common/hooks/usePoints'
import { Routes } from '@/src/common/enums/routes'
import { Link } from 'expo-router'
import { CardPaymentsE2E } from '@/src/experiences/card-payments/e2e'
import { DesignSystem } from '@/src/design-system'

const lineHeight = 24 satisfies TextStyle['lineHeight']

function Points({ active, testID }: { active?: PointsBalanceResponse['value']; testID: string }) {
  return (
    <Link href={Routes.PointsLedger.route} push asChild>
      <TouchableOpacity
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          alignItems: 'flex-end',
          flexWrap: 'nowrap',
        }}
        testID={testID}
      >
        {typeof active === 'number' ? (
          <Text
            style={[
              typography['Base Bold'],
              { color: mesaColorNames['Mesa - Brand/White #FFFFFF'], lineHeight },
            ]}
          >
            {active.toLocaleString()}
          </Text>
        ) : null}
        <Text
          style={[
            typography.Base,
            { color: mesaColorNames['Mesa - Brand/White #FFFFFF'], lineHeight },
          ]}
        >{`\u00a0Points`}</Text>
      </TouchableOpacity>
    </Link>
  )
}

export function PointsBalance() {
  const points = usePoints()
  return typeof points.query.data?.getPointsBalance.active.value === 'number' ? (
    <Points
      active={points.query.data.getPointsBalance.active.value}
      testID={CardPaymentsE2E.Ids.Press.PointsBalance}
    />
  ) : points.query.loading ? (
    <>
      <DesignSystem.Skeleton.Skeleton
        style={{ height: lineHeight, width: 88 }}
        skeletonProps={{ height: lineHeight }}
      />
      <Points testID={CardPaymentsE2E.Ids.Press.LoadingPointsBalance} />
    </>
  ) : (
    <Points active={0} testID={CardPaymentsE2E.Ids.Press.ZeroPointsBalance} />
  )
}
